import * as React from "react";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpSelect } from "../../../gvc/testNewForm/CpSelect";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpErrorWarningArray } from "../../../gvc/testNewForm/CpErrorWarningArray";
import { CpLabelDirtyIndicator } from "../../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "../only";
import { ResourceValidationAlert } from "./ResourceValidationAlert";

interface Props {
  index: number;
}
export const WorkloadContainerResources: React.FC<Props> = React.memo(({ index }) => {
  const type = useCpFormValue(`type`);
  const capacityAi = useCpFormValue(`defaultOptions.capacityAI`);

  const hasMinResources = capacityAi || type === "stateful";

  return (
    <>
      <CpFormItem noMargin>
        <div className="flex gap-8">
          {hasMinResources ? (
            <div className="flex gap-2">
              <div className="flex flex-col">
                <CpLabel name={`containers.${index}.minCpu.amount`}>
                  Min CPU
                  <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                    <CpLabelDirtyIndicator name={`containers.${index}.minCpu`} />
                  </Only>
                </CpLabel>
                <CpInput name={`containers.${index}.minCpu.amount`} style={{ width: 240 }} />
              </div>
              <div className="flex flex-col">
                <CpLabel name={`containers.${index}.minCpu.unit`}>Unit</CpLabel>
                <CpSelect
                  name={`containers.${index}.minCpu.unit`}
                  options={[
                    { label: "Millicores", value: "m" },
                    { label: "Cores", value: "" },
                  ]}
                  style={{ width: 180 }}
                />
              </div>
            </div>
          ) : null}
          <div className="flex gap-2">
            <div className="flex flex-col">
              <CpLabel name={`containers.${index}.cpu.amount`}>
                {hasMinResources ? "Max CPU" : "Reserved CPU"}
                <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                  <CpLabelDirtyIndicator name={`containers.${index}.cpu`} />
                </Only>
              </CpLabel>
              <CpInput name={`containers.${index}.cpu.amount`} style={{ width: 240 }} />
            </div>
            <div className="flex flex-col">
              <CpLabel name={`containers.${index}.cpu.unit`}>Unit</CpLabel>
              <CpSelect
                name={`containers.${index}.cpu.unit`}
                options={[
                  { label: "Millicores", value: "m" },
                  { label: "Cores", value: "" },
                ]}
                style={{ width: 180 }}
              />
            </div>
          </div>
        </div>
        <CpErrorWarningArray names={[`containers.${index}.minCpu.amount`, `containers.${index}.cpu.amount`]} />
      </CpFormItem>
      {/* <MountOptionsCpuError /> */}
      <CpFormItem>
        <div className="flex gap-8">
          {hasMinResources ? (
            <div className="flex gap-2">
              <div className="flex flex-col">
                <CpLabel name={`containers.${index}.minMemory.amount`}>
                  Min Memory
                  <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                    <CpLabelDirtyIndicator name={`containers.${index}.minMemory`} />
                  </Only>
                </CpLabel>
                <CpInput name={`containers.${index}.minMemory.amount`} style={{ width: 240 }} />
              </div>
              <div className="flex flex-col">
                <CpLabel name={`containers.${index}.minMemory.unit`}>Unit</CpLabel>
                <CpSelect
                  name={`containers.${index}.minMemory.unit`}
                  options={[
                    { label: "Mi (Mebibytes)", value: "Mi" },
                    { label: "Gi (Gibibytes)", value: "Gi" },
                    { label: "K8s Memory", value: "k8s" },
                  ]}
                  style={{ width: 180 }}
                />
              </div>
            </div>
          ) : null}
          <div className="flex gap-2">
            <div className="flex flex-col">
              <CpLabel name={`containers.${index}.memory.amount`}>
                {hasMinResources ? "Max Memory" : "Reserved Memory"}
                <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                  <CpLabelDirtyIndicator name={`containers.${index}.memory`} />
                </Only>
              </CpLabel>
              <CpInput name={`containers.${index}.memory.amount`} style={{ width: 240 }} />
            </div>
            <div className="flex flex-col">
              <CpLabel name={`containers.${index}.memory.unit`}>Unit</CpLabel>
              <CpSelect
                name={`containers.${index}.memory.unit`}
                options={[
                  { label: "Mi (Mebibytes)", value: "Mi" },
                  { label: "Gi (Gibibytes)", value: "Gi" },
                  { label: "K8s Memory", value: "k8s" },
                ]}
                style={{ width: 180 }}
              />
            </div>
          </div>
        </div>
        <CpErrorWarningArray names={[`containers.${index}.minMemory.amount`, `containers.${index}.memory.amount`]} />
      </CpFormItem>
      <ResourceValidationAlert containerIndex={index} />
    </>
  );
});
